import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';
import { ChecksumCalculator } from '../utils/ChecksumCalculator.js';

/**
 * Aadhaar validator following Single Responsibility Principle
 */
export class AadhaarValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Aadhaar Card',
      pattern: /^\d{12}$/,
      length: 12
    });
  }

  validateFormat(id) {
    // Check length
    const lengthValidation = this.validateLength(id, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern (all digits)
    return this.validateRegex(
      id,
      this.config.pattern,
      'Aadhaar must be exactly 12 digits'
    );
  }

  validateChecksum(id) {
    const first11Digits = id.slice(0, 11);
    const expectedChecksum = ChecksumCalculator.calculateVerhoeffChecksum(first11Digits);
    const actualChecksum = parseInt(id.slice(-1));

    if (expectedChecksum !== actualChecksum) {
      return ValidationResult.invalid(
        `Invalid Aadhaar checksum. Expected: ${expectedChecksum}, Got: ${actualChecksum}`
      );
    }

    return ValidationResult.valid('Valid Aadhaar');
  }
}